// extracted by mini-css-extract-plugin
export default {"root":"inventory_root__TZTOr","inventory_container":"inventory_inventory_container__lQUzo"};